// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { EnvImpl } from './env-impl';
/**
 * Represent a set of flags as a global singleton.
 */
export const env = new EnvImpl();
//# sourceMappingURL=env.js.map